import React from 'react';
import {Button, Col, Row} from 'react-bootstrap';
import TextField from "@mui/material/TextField"
import {Checkbox} from '@mui/material';
import {getToken} from "../../Utils/Common";

const GeraeteComponent = ({
                              setDeviceList, deviceList
                          }) => {


    const inputStyles = {
        marginTop: "1rem",
    }

    const [isDisabled, setIsDisabled] = React.useState(false)

    React.useEffect(() => {
        if (deviceList.length > 1) {
            deviceList[deviceList.length - 1].name === "" ? setIsDisabled(true) : setIsDisabled(false)
        }
    })

    const handleListAdd = () => {
        setDeviceList([...deviceList, {
            name: "", status: false, id: null
        }])
    }

    const saveGeraete = async (event, deviceData) => {

        let apiBody = {
            "token": getToken(),
            "data": {"organisationID": sessionStorage.getItem("org"), "deviceData": deviceData}
        }
        let serverResponse = await fetch(process.env.REACT_APP_BACKEND_API_URI + "mobileappbackend/create_devices", {
            method: 'POST', headers: {
                'Content-type': 'application/json',
            }, body: JSON.stringify(apiBody),
        })
            .then((response) => response.json())
            .catch((error) => {
                console.error('Error:', error);
            })

        if (serverResponse.status === 200) {
            alert("Geraete erfolgreich erstellt")
        } else {
            alert("Geraete konnte nicht erstellt werden")
        }
    }

    const handleInputChange = (key, event, index) => {

        const {value} = event.target
        const newInputList = [...deviceList]
        newInputList[index][key] = value
        newInputList[index].id = (index + 1).toString()
        setDeviceList(newInputList)
    }

    const handleStatusChange = (key, event, index) => {

        const newInputList = [...deviceList]
        newInputList[index][key] = event.target.checked
        newInputList[index].id = (index + 1).toString()
        setDeviceList(newInputList)
    }

    const handleDeleteChange = async (event, id) => {
        //setIsActivated(event.target.checked)
        const newInputList = [...deviceList]
        newInputList.splice(newInputList.findIndex(function (i) {
            return i.id === id;
        }), 1);

        setDeviceList(newInputList)
        await saveGeraete(event, newInputList)
    }


    return (<>

        <Row>
            <Col sm={1}/>
            <Col>
                <div>
                    <Button className="handwai-btn-create" onClick={handleListAdd} disabled={isDisabled}>+</Button>
                </div>
                {/*<label className='handwai-text-label-normal'>Geraete</label>*/}
            </Col>
            <Col>


            </Col>
            <Col sm={8}/>
        </Row>
        <br/>
        <Row>
            <Col sm={1}/>


            <Col>
                {deviceList.length > 0 ? deviceList.map((input, index) => (<div key={index} style={inputStyles}>
                    <TextField
                        id="readOnlyField"
                        label="ID"
                        value={index + 1}
                        InputLabelProps={{
                            style: {
                                color: "white"
                            }
                        }}
                        InputProps={{
                            readOnly: true, style: {
                                color: "white", width: 40
                            }
                        }}
                    />
                    <TextField
                        id="Bezeichnung"
                        required
                        label="Bezeichnung"
                        value={input.name}
                        onChange={(event) => handleInputChange("name", event, index)}
                        InputLabelProps={{
                            style: {
                                color: "white"
                            }
                        }}
                        InputProps={{
                            style: {
                                color: "white", borderColor: "white"
                            }, placeholder: "name", classes: {
                                root: "white-input", notchedOutline: "white-border"
                            }
                        }}
                    />

                    <Checkbox
                        id={"status"}
                        label={"Status"}
                        checked={input.status}
                        onChange={(event) => handleStatusChange("status", event, index)}
                    />

                    <Button className={"btn btn-danger"}
                            onClick={(event) => handleDeleteChange(event, input.id)}> X </Button>

                </div>)) : "kein Datei"}

            </Col>


            <Col/>
        </Row>
        <br/>
        <br/>
        <Row>

            <Col sm={1}></Col>

            <Col>

                <Button
                    className="handwai-btn-create"
                    onClick={(event) => saveGeraete(event, deviceList)}
                >Speichern</Button>

            </Col>

        </Row>

    </>)

}

export default GeraeteComponent;